const PRELOADED = ['assets/images/venuslarge.gif',
    'assets/images/earthlarge.gif',
    'assets/images/marslarge.gif',
    'assets/images/jupiterlarge.gif',
    'assets/images/saturnlarge.gif',
    'assets/images/uranuslarge.png',
    'assets/images/neptunelarge.gif'];
const BACKGROUND = 'assets/images/Milky-Way-2b.png';
const MIN_TIMEOUT = 1200;


let progBar, timer;
function handleLoader(loaded) {
    progBar.style.width = (loaded / (PRELOADED.length + 1)) * 100 + '%';
    if (loaded === (PRELOADED.length + 1)) {
        let deltaTimeout = new Date().getTime() - timer;
        if(deltaTimeout < MIN_TIMEOUT) {
            window.setTimeout(function() {
                document.getElementById('ss-loader').style.display = 'none';
            }, MIN_TIMEOUT - deltaTimeout);
        } else {
            document.getElementById('ss-loader').style.display = 'none';
        }
    }
}

module.exports = {

    cacheImages : [],

    readJSON : function (path, callback) {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', path, true);
        xhr.responseType = 'blob';
        xhr.onload = function (e) {
            if (this.status == 200) {
                let file;
                try {
                    file = new File([this.response], 'temp');
                } catch(e) {
                    file = new Blob([this.response], { type: 'application/json' });
                }
                let fileReader = new FileReader();
                fileReader.addEventListener('load', function () {
                    callback.call(window, JSON.parse(fileReader.result));
                });
                fileReader.readAsText(file);
            }
        }
        xhr.send();
    },

    preloadImages : function() {
        let cacheEl = document.getElementById('ss-img-cache'), loaded = 0, mw;
        timer = new Date().getTime();
        progBar = document.getElementById('ss-loader-prog-bar');
        mw = new Image();
        mw.src = BACKGROUND;
        mw.onload = function() {
            document.getElementById('ss-container').style.backgroundImage = 'url(' + mw.src + ')';
            loaded++;
            handleLoader(loaded);
        };
        for (let i = 0; i < PRELOADED.length; i++) {
            this.cacheImages[i] = new Image();
            this.cacheImages[i].src = PRELOADED[i];
            //cacheEl.appendChild(cacheImages[i]);
            this.cacheImages[i].onload = function() {
                loaded++;
                handleLoader(loaded);
            }
        }
    }
}
